import {
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2
} from '@angular/core';
import { ScrollSpyService } from '../_services/scroll-spy.service';

@Directive({
  selector: '[sdSpyTarget]',
  standalone: true
})
export class SdSpyTargetDirective implements OnInit, OnDestroy {
  constructor(
    private el: ElementRef,
    private scrollSpyService: ScrollSpyService,
    private renderer: Renderer2,
  ) {}

  @Input()
  readonly sdSpyTarget: string;

  ngOnInit() {
    this.renderer.setAttribute(this.el.nativeElement, 'id', this.sdSpyTarget);
    this.scrollSpyService.addTarget({
      name: this.sdSpyTarget,
      element: this.el
    });
  }

  ngOnDestroy() {
    this.scrollSpyService.removeTarget(this.sdSpyTarget);
  }
}
